import ImageBrowser from './image-browser'

export default {
  install (Vue) {
    Vue.component('ImageBrowser', ImageBrowser)
  }
}
